import { useMemo } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioCurrencySign } from "web_myplann/Portfolio/Helpers/getPortfolioCurrencySign";

export const useCurrencySign = (currency: string | null | undefined) => {
	const { t } = useResource();

	return useMemo(
		() => (currency ? getPortfolioCurrencySign(t, currency) : ""),
		[currency, t],
	);
};
